import React, { useState, useEffect } from "react";
import {
  Link,
  Box,
  MenuItem,
  Menu,
  IconButton,
  Typography,
  Divider,
} from "@mui/material";
import PermIdentityOutlinedIcon from "@mui/icons-material/PermIdentityOutlined";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useNavigate, useLocation } from "react-router-dom";
import { StyledMenuButton } from "./style";
import ConfirmDialog from "./dialog";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import Logo from "assets/images/logo/logo.png";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";

const Navbar = ({
  menus,
  currentUser,
  handleMouseEnter,
  handleMouseLeave,
  signOut,
  handleSignInClick,
  quoteCount,
  // [보류] 견적 문의 카트 비활성화
  // inquiryCount,
  isAdmin,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

  const handleMenuClick = (menu) => {
    navigate(menu.to);
    setActiveMenu(menu.key);
  };
  useEffect(() => {
    const currentMenu = menus.find((menu) =>
      location.pathname.includes(menu.key)
    );
    setActiveMenu(currentMenu ? currentMenu.key : null);
  }, [location, menus]);

  useEffect(() => {
    setAnchorEl(null);
  }, [location]);

  const handleAccountIconClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogoutClick = () => {
    setLogoutDialogOpen(true);
  };

  const confirmLogout = () => {
    signOut();
    handleClose();
    setLogoutDialogOpen(false);
  };

  const cancelLogout = () => {
    setLogoutDialogOpen(false);
  };
  const handleNavigate = (path) => {
    handleClose();
    navigate(path);
  };

  return (
    <>
      <Box className="menus">
        {menus.map((menu) => {
          const isActive = activeMenu === menu.key;
          return (
            <Box
              key={menu.key}
              className="menu"
              onMouseEnter={() => handleMouseEnter(menu)}
              onMouseLeave={handleMouseLeave}
            >
              <StyledMenuButton
                variant="text"
                disableRipple
                active={isActive}
                onClick={() => menu.to && handleMenuClick(menu)}
                to={menu.to}
              >
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  lineHeight={1.15}
                >
                  <Typography component="span" fontSize="16px">
                    {menu.name}
                  </Typography>
                  {menu.englishName && (
                    <Typography
                      component="span"
                      fontSize="10px"
                      sx={{ opacity: 0.65 }}
                    >
                      {menu.englishName}
                    </Typography>
                  )}
                </Box>
              </StyledMenuButton>
            </Box>
          );
        })}

        {/* 장바구니(발주)는 상단 메뉴의 마지막 항목으로 노출한다.
            다른 메뉴와 동일하게 hover/현재 페이지 표시(주황색 점)가 동작하도록
            StyledMenuButton 을 사용한다. */}
        {!isAdmin && (
          <Box
            className="menu"
            onMouseEnter={handleMouseLeave}
            onMouseLeave={handleMouseLeave}
          >
            <StyledMenuButton
              variant="text"
              disableRipple
              active={location.pathname.includes("/cart/quote")}
              to="/cart/quote"
              onClick={() => {
                if (!location.pathname.includes("/cart/quote")) {
                  handleNavigate("/cart/quote");
                }
              }}
            >
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                lineHeight={1.15}
              >
                <Typography component="span" fontSize="16px">
                  장바구니
                </Typography>
                <Typography
                  component="span"
                  fontSize="10px"
                  sx={{ opacity: 0.65 }}
                >
                  Cart
                </Typography>
              </Box>
              <Box display="flex" alignItems="center" position="relative">
                <ShoppingBagIcon sx={{ ml: 1, fontSize: "18px" }} />
                {quoteCount > 0 && (
                  <Box
                    sx={{
                      position: "absolute",
                      top: -10,
                      right: -10,
                      backgroundColor: "primary.orange",
                      borderRadius: "50%",
                      width: "20px",
                      height: "20px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "white",
                    }}
                  >
                    <Typography variant="small" fontWeight="bold">
                      {quoteCount > 99 ? "99+" : quoteCount}
                    </Typography>
                  </Box>
                )}
              </Box>
            </StyledMenuButton>
          </Box>
        )}
      </Box>

      <Box display="flex" alignItems="center">
        {currentUser ? (
          <>
            <IconButton
              onClick={handleAccountIconClick}
              sx={{ color: "white" }}
            >
              <AccountCircleIcon />
            </IconButton>

            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{ "aria-labelledby": "account-button" }}
              sx={{
                zIndex: 2000,
                display: anchorEl ? "block" : "none",
              }}
            >
              <MenuItem
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "5px",
                  pointerEvents: "none",
                }}
              >
                <Typography
                  variant="body"
                  color="gray.main"
                  fontSize="0.8rem"
                  fontWeight="bold"
                  marginRight="auto"
                >
                  ACCOUNT
                </Typography>
                <Box display="flex" gap="1rem">
                  <Box
                    sx={{
                      border: "1px solid #e0e0e0",
                      borderRadius: "50%",
                      padding: "5px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={Logo}
                      alt="Prime Solution  Logo"
                      width="35"
                      height="20"
                    />
                  </Box>
                  <Box>
                    <Typography variant="body">
                      {currentUser.company || ""}
                    </Typography>
                    <Typography variant="small">{currentUser.email}</Typography>
                  </Box>
                </Box>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleClose();
                  navigate("/profile");
                }}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Typography>내 정보</Typography>
                <OpenInNewIcon fontSize="small" />
              </MenuItem>
              {isAdmin && (
                <MenuItem
                  onClick={() => {
                    handleClose();
                    navigate("/admin");
                  }}
                >
                  관리자 페이지
                </MenuItem>
              )}

              <Divider />
              <Box>
                <MenuItem
                  onClick={() => {
                    handleClose();
                    navigate("/my-inquiry");
                  }}
                >
                  {isAdmin ? "견적 문의 리스트" : "제출된 견적 문의"}
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleClose();
                    navigate("/my-quote");
                  }}
                >
                  {isAdmin ? "발주 문의 리스트" : "제출된 발주 문의"}
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleClose();
                    handleLogoutClick();
                  }}
                >
                  로그아웃
                </MenuItem>
              </Box>
            </Menu>
            <ConfirmDialog
              open={logoutDialogOpen}
              title="Confirm Logout"
              message="로그아웃 하시겠습니까?"
              onClose={cancelLogout}
              onConfirm={confirmLogout}
              confirmText="확인"
              cancelText="취소"
            />
          </>
        ) : (
          <MenuItem component={Link} disableRipple onClick={handleSignInClick}>
            <PermIdentityOutlinedIcon />
          </MenuItem>
        )}
      </Box>
    </>
  );
};

export default Navbar;
